import Vue from 'vue';
import messageMaker from '@/components/pages/AdminHomePage/messages/Messages/messageMaker.vue'
import messageHistory from '@/components/pages/AdminHomePage/messages/Messages/messageHistory.vue'
import emailSubscribers from '@/components/pages/AdminHomePage/messages/Messages/emailSubscribers.vue'

Vue.component('message-maker', messageMaker);
Vue.component('message-history', messageHistory);
Vue.component('email-subscribers', emailSubscribers);
